// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"W5-z"};